import { render, staticRenderFns } from "./ImportOrder.vue?vue&type=template&id=59d0b1d2"
import script from "./ImportOrder.vue?vue&type=script&lang=js"
export * from "./ImportOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports